import { render } from "./ios_version.vue?vue&type=template&id=6b2b1633&scoped=true"
import script from "./ios_version.vue?vue&type=script&lang=js"
export * from "./ios_version.vue?vue&type=script&lang=js"

import "./ios_version.vue?vue&type=style&index=0&id=6b2b1633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2b1633"]])

export default __exports__